import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { spacing } from "../../../../styles/styles.constants";

export const ViewerPollsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const PollCard = styled.div`
	padding: ${spacing.padding};
	border-radius: ${spacing.borderRadius};
	border: solid 1px ${colours.greyMedium};
	background: ${colours.greyLight};
`;
